import styled from 'styled-components';
import Colors from '../../config/Colors';

export const Button = styled.button`
    border: none;
    min-width: 180px;
    min-height: 50px;
    color: white;
    background-color: ${({ disabled }) =>
        disabled ? `${Colors.border}` : `${Colors.blue_button}`};
    font-family: NunitoSans-Bold;
    border-radius: 4px;

    &:hover {
        cursor: pointer;
    }

    &:active {
        opacity: 0.5;
    }
`;
